import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BWModalBody = React.forwardRef(({ children, className, loading, loadingLabel = 'Đang xử lý', style }, ref) => (
  <div ref={ref} className={classNames('bw_modal_ds_body', className)} style={style}>
    {children}
    {loading ? (
      <div className='bw_modal_ds_loading' role='status' aria-live='polite' aria-label={loadingLabel}>
        <span className='bw_modal_ds_spinner' aria-hidden='true' />
        <span>{loadingLabel}</span>
      </div>
    ) : null}
  </div>
));

BWModalBody.displayName = 'BWModalBody';

BWModalBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  style: PropTypes.object,
};

export default BWModalBody;
